import $ from 'jquery';

export default function(API) {
	return (selector = '.top-ad-bar') => {
		$(`${selector}.short`).on('click', function() {
			const bodyHeightShift = $(`${selector}.full`).outerHeight() - $(`${selector}.short`).outerHeight();
			$('.page').addClass('top-ad-bar-open');
			$('.page').css('transform', `translate3d(0, ${bodyHeightShift}px, 0)`);
			$(this).toggleClass('closed').toggleClass('open');
			$(`${selector}.full`).toggleClass('closed').toggleClass('open');
		});
		$(`${selector}.full`).on('click close-full-ad-bar', function() {
			if ($('.page').hasClass('top-ad-bar-open')) {
				$('.page').css('transform', '');
				$(this).toggleClass('closed').toggleClass('open');
				$(`${selector}.short`).toggleClass('closed').toggleClass('open');
				$('.page').removeClass('top-ad-bar-open');
			}
		});
	}
}
